import { useSearchParams } from 'react-router-dom';

import { SEARCH_PARAM_INCIDENT_SEARCH } from '@/utils/constants/queries';

const useIncidentSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchKey = searchParams.get(SEARCH_PARAM_INCIDENT_SEARCH) ?? '';

  const setSearchKey = (value: string) => {
    const current = searchParams.get(SEARCH_PARAM_INCIDENT_SEARCH) ?? '';

    if (value === current) {
      return;
    }

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);

        if (value) {
          next.set(SEARCH_PARAM_INCIDENT_SEARCH, value);
        } else {
          next.delete(SEARCH_PARAM_INCIDENT_SEARCH);
        }

        return next;
      },
      { replace: true }
    );
  };

  return { searchKey, setSearchKey };
};

export default useIncidentSearch;
